export { default } from './PatientLabels';
